<div *ngIf="item && show"
     class="content-card microtext-card" [class.show]="show" [class.inline]="inline" [class.active]="active">
  <div *ngIf="canClose" class="close-btn" (click)="closeCard()">
    <app-icon class="close-btn-icon" icon="close"></app-icon>
  </div>

  <div class="header">
    <div class="author">
      <div class="author-avatar-wrap">
        <on-ui-cover [cover]="authorImg" [attr.data-test] = "'authorPhoto'"></on-ui-cover>
      </div>
      <div class="info">
        <p *ngIf="author" class="author-block">
          <a class="author-name" [routerLink]="accountRoute(author)" itemprop="author">{{ authorFullName }}</a>
          <app-subscribe [user_id]="authorId"></app-subscribe>
        </p>
        <div class="stats-wrap">
          <app-rating [stats]="stats" [user]="author"></app-rating>
          <span class="published-date" *ngIf="isAuthUser">{{ contentDate | dfnsFormatDistanceToNowStrictPure: {addSuffix: true} }}</span>
        </div>
      </div>
    </div>
    <div class="toolbar" *ngIf="isBrowser && me && !state.removed">
      <div class="copied-informer" [class.active]="state.copied"><span>{{'invite-card.link-copied' | customLocale}}</span></div>
      <on-ui-card-menu [item]="item">
        <div class="menu-item"
             *ngIf="isAuthor && !isOld && !state.editing">
          <span (click)="openEditor()">{{ 'library.menu-edit' | customLocale }}<!--Изменить--></span>
        </div>
        <div class="menu-item"
             *ngIf="isAuthor">
          <span (click)="archive()">{{ 'library.menu-remove' | customLocale }}<!--Удалить--></span>
        </div>

        <div class="menu-item"
             *ngIf="state.subscribed"
             (click)="unsubscribe()">{{ 'library.menu-unsubscribe' | customLocale }}</div>
        <div class="menu-item" #shareLinkRef *ngIf="contentUrl && isAvailableStatistics">
          <button type="button"
                  [ngxClipboard]
                  [cbContent]="contentUrl"
                  (cbOnSuccess)="onCopied($event)"
                  [container]="shareLinkRef">{{ 'library.menu-share' | customLocale }}<!-- Поделиться -->
          </button>
        </div>
        <div class="menu-item"
             *ngIf="!isAuthor && isAccessGranted"
             (click)="openComplainForm()">{{ 'library.menu-complain' | customLocale }}<!-- Пожаловаться --></div>
      </on-ui-card-menu>
    </div>

    <div *ngIf="state.removed"
         class="removed-alert"
         (click)="restore()">{{ 'library.publication-removed-text' | customLocale }} <span class="link">{{ 'library.publication-restore-action' | customLocale }}</span></div>
  </div>

  <div class="form" [formGroup]="form" *ngIf="form && state.editorLoaded && state.editing">
    <div class="editor-wrap">
      <ng-template [ngIf]="false">
      </ng-template>
      <div class="editor-content" [class.active]="state.editorInFocus">
        <editor class="rich-editor"
                [init]="editorConfig"
                (onFocus)="state.editorInFocus = true"
                (onBlur)="state.editorInFocus = false"
                formControlName="text">
        </editor>
      </div>
      <div class="smiles"></div>
    </div>
  </div>

  <div class="actions" *ngIf="form && state.editorLoaded && state.editing">
    <div class="toolbar"></div>
    <div class="button-wrap">
      <div class="clear-button normal" (click)="cancel()">{{ 'library.cancel-action' | customLocale }}</div>
      <on-ui-button [state]="state.saveButton"
                    [disabled]="!readyForSave"
                    label="library.update-action"
                    class="secondary"
                    (onclick)="save()">
      </on-ui-button>
    </div>
  </div>

  <div class="content rich-html" [class.blur]="state.removed" *ngIf="!state.editing">
    <div [innerHTML]="item.text | sanitizeHtml"></div>
  </div>

  <svg height="1px" xmlns="http://www.w3.org/2000/svg" version="1.1">
    <defs>
      <filter id="blur"><feGaussianBlur in="SourceGraphic" stdDeviation="10, 10" /></filter>
    </defs>
  </svg>

  <ng-template [ngIf]="item">
    <app-share-and-stats
      [content_id]="item.id"
      [stats]="item.stats"
      [visit_info]="item.visit_info"
      (shared)="onCopied($event)"
      (changed)="onShareAndStatsChange($event)"></app-share-and-stats>

    <app-content-comments
      [content]="item"
      (commented)="setIsCommented()"
      (changed)="onCommentsChange($event)"></app-content-comments>
  </ng-template>
</div>

<app-modal *ngIf="state.complainFormOpened && deviceService.isDesktop()"
           (closed)="closeComplainForm()"
           canClose="true"
           middle="true">
  <app-modal-body>
    <app-complaint-form [type]="'content'"
                        (cancel)="closeComplainForm()"></app-complaint-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="state.complainFormOpened && !deviceService.isDesktop()"
                  [titleVisible]="false"
                  (closed)="closeComplainForm()">
  <app-mobile-modal-body>
    <app-complaint-form [type]="'content'"
                        (cancel)="closeComplainForm()"></app-complaint-form>
  </app-mobile-modal-body>
</app-mobile-modal>
